import { Typography } from '@mui/material';

import { useAppSelector } from 'shared/hooks/store';
import { useUser } from 'shared/hooks/user';
import { getFullName } from 'shared/utils/user';

import { Wrapper } from './components/Wrapper';

import type { FC } from 'react';

export const USER_SECTION_TEST_ID = 'user-section';

export const UserSection: FC = () => {
  const user = useUser();
  const { opened } = useAppSelector(state => state.sidebar);

  if (!user) {
    return null;
  }

  return (
    <Wrapper data-testid={USER_SECTION_TEST_ID} opened={opened}>
      <Typography variant="body2">{getFullName(user)}</Typography>
      <Typography variant="caption" color="text.secondary" noWrap>
        {user.emailAddress}
      </Typography>
    </Wrapper>
  );
};
